import React from 'react';
import ProjectsTable from './ProjectsTable';

export default function ProjectsListScreen() {
	return <ProjectsTable />;
}
